/**
 * Uncomment this only if you have js functionality for the component
 * 
 */

jQuery(document).ready(function () {
    jQuery('.show-more').each((i, ele) => {
        jQuery(ele).on('click', function (el) {
            el.preventDefault();
            jQuery(this).toggleClass('show-less');

            var parent = jQuery(this).parent().parent().parent();

            parent.find(".m-description").slideToggle();
            parent.find('.m-social-media').toggleClass('m-sm-hover');
        });
    });
    jQuery('.card-team .m-picture-inner').on('click', 'img', function () {
        jQuery(this).parents('.card-team').find(".show-more").toggleClass('show-less');
        jQuery(this).parents('.card-team').find(".m-description").slideToggle();
        jQuery(this).parents('.card-team').find('.m-social-media').toggleClass('m-sm-hover');
    });
});